import { BookOpenTextIcon as PhosphorBookOpenTextIcon } from "@phosphor-icons/react/dist/ssr/BookOpenText";

import { createAppIcon } from "@/components/createAppIcon";

export const StoriesIcon = /* @__PURE__ */ createAppIcon(PhosphorBookOpenTextIcon);
